/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
export const getEnabledSkinnyRailVerbs = stores => stores.skinnyRailStore.enabledVerbs;
import { DEFAULT_RHP_WIDTH } from "constants/constants";

export const getTopUIControls = stores => stores.skinnyRailStore.topUIControls;

export const getBottomUIControls = stores => stores.skinnyRailStore.bottomUIControls;

export const getRhpWidth = () => DEFAULT_RHP_WIDTH;
